module.exports = __webpack_public_path__ + "img/2.826a2c6a.png";